'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconChart = function IconChart(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ width: '24px', height: '24px', viewBox: '0 0 24 24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M20.1255,20.8725 L3.75,20.8725 C3.33525,20.8725 3,20.5425 3,20.1225 L3,3.75 C3,3.3375 3.33525,3 3.75,3 C4.164,3 4.5,3.3375 4.5,3.75 L4.5,19.3725 L20.1255,19.3725 C20.5395,19.3725 20.8755,19.71 20.8755,20.1225 C20.8755,20.5425 20.5395,20.8725 20.1255,20.8725' }),
      ' ',
      _react2.default.createElement('path', { d: 'M7.14375,16.77 L8.52525,16.77 L8.52525,14.28 L7.14375,14.28 L7.14375,16.77 Z M9.21825,18.1575 L6.45075,18.1575 C6.06825,18.1575 5.75925,17.8425 5.75925,17.46 L5.75925,13.59 C5.75925,13.2075 6.06825,12.8925 6.45075,12.8925 L9.21825,12.8925 C9.6,12.8925 9.909,13.2075 9.909,13.59 L9.909,17.46 C9.909,17.8425 9.6,18.1575 9.21825,18.1575 L9.21825,18.1575 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M17.83275,16.77 L19.21575,16.77 L19.21575,4.44 L17.83275,4.44 L17.83275,16.77 Z M19.90725,18.1575 L17.13975,18.1575 C16.75725,18.1575 16.44825,17.8425 16.44825,17.46 L16.44825,3.75 C16.44825,3.3675 16.75725,3.06 17.13975,3.06 L19.90725,3.06 C20.289,3.06 20.5995,3.3675 20.5995,3.75 L20.5995,17.46 C20.5995,17.8425 20.289,18.1575 19.90725,18.1575 L19.90725,18.1575 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M12.4875,16.77 L13.8705,16.77 L13.8705,9.465 L12.4875,9.465 L12.4875,16.77 Z M14.562,18.1575 L11.796,18.1575 C11.4135,18.1575 11.103,17.8425 11.103,17.46 L11.103,8.775 C11.103,8.3925 11.4135,8.085 11.796,8.085 L14.562,8.085 C14.94375,8.085 15.25425,8.3925 15.25425,8.775 L15.25425,17.46 C15.25425,17.8425 14.94375,18.1575 14.562,18.1575 L14.562,18.1575 Z' }),
      ' '
    )
  );
};

IconChart.propTypes = {
  color: _propTypes2.default.string
};

IconChart.defaultProps = {
  color: _colors2.default.icons
};

IconChart.displayName = 'IconChart';

exports.default = IconChart;
module.exports = exports.default;